import { render, staticRenderFns } from "./ListStockTransfer.vue?vue&type=template&id=019c2b84"
import script from "./ListStockTransfer.vue?vue&type=script&lang=js"
export * from "./ListStockTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports